export default __webpack_public_path__ + "static/media/17.35d64571.png";